import { NotificationService } from '@capsicum/common';
import { type FC, useCallback } from 'react';

type UseV2FTMigrationListenersProps = {
	refetchNcwBalance: () => void;
	snackbar: FC;
};

export const useV2FTMigrationListeners = ({
	refetchNcwBalance,
	snackbar: Snackbar
}: UseV2FTMigrationListenersProps) => {
	const v2FTMigrationSuccessEventHandler = useCallback(() => {
		refetchNcwBalance();

		NotificationService.addNotification({
			component: <Snackbar />
		});
	}, [Snackbar, refetchNcwBalance]);

	return {
		v2FTMigrationSuccessEventHandler
	};
};
